import {
  RoiAggregatesV2,
  RoiNoShowRate,
  RoiNoShowRateAggregates,
} from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import dayjs from 'dayjs';
import { demoDataUtils } from '../../../../utils';

const subscribedTrend = [0.97, 0.99, 0.98, 0, 0.85, 0.94];
const unsubscribedTrend = [0.5, 0.6, 0.55, 0.26, 0.65, 0.75];

const last6Months = Array.from({ length: 6 }, (_, i) => i)
  .map((i) => {
    return dayjs()
      .subtract(i + 1, 'month')
      .format('MMM');
  })
  .reverse();

export const generateOverviewDemoData = (locationIds: string[]): RoiAggregatesV2 => {
  return {
    data: locationIds.map((locationId) => ({
      appointmentsCompleted: demoDataUtils.generateRandomInt(1000, 1200),
      appointmentsCompletedPatients: demoDataUtils.generateRandomInt(800, 1000),
      appointmentsConfirmed: demoDataUtils.generateRandomInt(1000, 1200),
      appointmentsConfirmedPatients: demoDataUtils.generateRandomInt(1000, 1200),
      locationId: locationId,
      patients: demoDataUtils.generateRandomInt(100, 1200),
      sent: demoDataUtils.generateRandomInt(1200, 1500),
      totalAppointmentsCompleted: demoDataUtils.generateRandomInt(1200, 1600),
      totalAppointments: demoDataUtils.generateRandomInt(1500, 1600),
    })),
    message: '',
  };
};

export const generateNoShowRateTimelineDemoData = (): RoiNoShowRate => {
  return {
    data: {
      dates: last6Months.map((month, index) => {
        return {
          key: month,
          subscribed: subscribedTrend[index],
          unsubscribed: unsubscribedTrend[index],
        };
      }),
      rateDifference: 0.2,
    },
    message: '',
  };
};

export const generateNoShowRateLocationWiseDemoData = (locationIds: string[]): RoiNoShowRateAggregates => {
  return {
    data: {
      locations: locationIds.map((locationId) => ({
        locationId,
        noShowRate: demoDataUtils.generateRandomFloat(),
      })),
      unsubscribed: 0.7,
    },
    message: '',
  };
};
